
<div class="blocos-inline">
  <app-bloco-endereco-info 
    [Tipo]="'Remetente:'"
    [RazaoSocial]="pedido?.remRazaoSocial"
    [Endereco]="pedido?.remEndereco"
    [Bairro]="pedido?.remBairro"
    [Cidade]="pedido?.remMunicipio"
    [UF]="pedido?.remUf"
    [CEP]="pedido?.remCEP"
    [CGC]="pedido?.remCGC"
  ></app-bloco-endereco-info>

  <app-bloco-endereco-info
    [Tipo]="'Destinatário:'"
    [RazaoSocial]="pedido?.desRazaoSocial"
    [Endereco]="pedido?.desEndereco"
    [Bairro]="pedido?.desBairro"
    [Cidade]="pedido?.desMunicipio"
    [UF]="pedido?.desUF"
    [CEP]="pedido?.desCEP"
    [CGC]="pedido?.desCGC"
  ></app-bloco-endereco-info>
</div>

<div class="bloco-unico">
  <h3 class="uppercase">Dados da guia</h3>
  <hr>
  <div class="table-responsive">
    <table class="table">
      <thead>
        <tr>
          <th>Natureza</th>
          <th>Qtde/Vol</th>
          <th>Peso (Kg)</th>
          <th>Valor Original</th>
          <th>Lacre</th>
        </tr>
      </thead>
      <tbody>
        <tr>
          <td>{{pedido?.pedidoItem.natMerc}}</td>
          <td>{{pedido?.pedidoItem.qtde}}</td>
          <td>{{pedido?.pedidoItem.peso}}</td>
          <td>{{pedido?.pedidoItem.valor | currency : 'BRL'}}</td>
          <td>{{pedido?.pedidoItem.numLacre}}</td>
        </tr>
      </tbody>
    </table>
  </div>
</div>